import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ad6330c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "number-input-container" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value", "min", "max", "step"]
const _hoisted_4 = ["disabled"]

import { computed } from 'vue';

// Props

export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: Number,
    default: 0
  },
  min: {
    type: Number,
    default: -Infinity
  },
  max: {
    type: Number,
    default: Infinity
  },
  step: {
    type: Number,
    default: 1
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props



// Emits


// Computed properties
const isDecrementDisabled = computed(() => {
  return props.modelValue <= props.min;
});

const isIncrementDisabled = computed(() => {
  return props.modelValue >= props.max;
});

// Methods
const updateValue = (event: any) => {
  const value = parseFloat(event.target.value);
  if (!isNaN(value)) {
    const clampedValue = Math.min(Math.max(value, props.min), props.max);
    emit('update:modelValue', clampedValue);
  }
};

const increment = () => {
  if (!isIncrementDisabled.value) {
    const newValue = Math.min(props.modelValue + props.step, props.max);
    emit('update:modelValue', newValue);
  }
};

const decrement = () => {
  if (!isDecrementDisabled.value) {
    const newValue = Math.max(props.modelValue - props.step, props.min);
    emit('update:modelValue', newValue);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "number-input-btn decrement-btn",
      disabled: _unref(isDecrementDisabled),
      type: "button",
      onClick: decrement
    }, " - ", 8, _hoisted_2),
    _createElementVNode("input", {
      type: "number",
      class: "number-input",
      value: __props.modelValue,
      min: __props.min,
      max: __props.max,
      step: __props.step,
      onInput: updateValue
    }, null, 40, _hoisted_3),
    _createElementVNode("button", {
      class: "number-input-btn increment-btn",
      disabled: _unref(isIncrementDisabled),
      type: "button",
      onClick: increment
    }, " + ", 8, _hoisted_4)
  ]))
}
}

})